import { defineComponent } from "vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppLoading from "@/components/AppLoading/AppLoading.vue";
import AsyncKahiDetail from "@/views/KahiDetail/async/AsyncKahiDetail.vue";
import store from "@/store";

export default defineComponent({
  name: "KahiDetail",
  components: {
    AppHeader,
    AppLoading,
    AsyncKahiDetail
  },
  setup() {
    store.dispatch("kahi/getCurrentPosition");
  }
});
